import { Tooltip } from 'antd';
import { JobReferenceLink } from 'views/declarations/utils/declaration-utils';
import DotSeparator from 'components/new-ui/base/dot-separator/DotSeparator';
import { JobItem, JobLink, JobList, JobReference, Wrapper } from './styles';
import { InfoText, InfoTitle } from '../DeclarationInformation.styles';

type Props = {
    data: JobReferenceLink[];
};

const JobReferenceIdLinksList = ({ data }: Props) => {
    if (!data.length) return null;

    const label = data.length > 1 ? 'Job IDs' : 'Job ID';

    return (
        <Wrapper data-testid="declaration-information-job-id">
            <InfoTitle>{label}: </InfoTitle>
            <JobList>
                {data.map((job, index) => (
                    <JobItem key={job.jobId}>
                        {index > 0 && <DotSeparator />}
                        <Tooltip overlay={job.jobReference}>
                            {job.path ? (
                                <JobLink to={job.path} data-testid="declaration-information-job-link">
                                    <JobReference>{job.jobReference}</JobReference>
                                </JobLink>
                            ) : (
                                <InfoText>{job.jobReference}</InfoText>
                            )}
                        </Tooltip>
                    </JobItem>
                ))}
            </JobList>
        </Wrapper>
    );
};

export default JobReferenceIdLinksList;
